import { HEARTBEAT_ERROR, HEARTBEAT_START, HEARTBEAT_SUCCESS } from '../actions/heartbeat';

const initialState = {
    pulse: true,
    status: {
        error: false,
        fetching: false,
        loaded: false,
        httpStatus: null,
    },
};

export function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case HEARTBEAT_START:
            return {
                ...state,
                pulse: true,
                status: {
                    fetching: true,
                    error: false,
                    loaded: false,
                    httpStatus: null,
                },
            };
        case HEARTBEAT_SUCCESS:
            return {
                ...state,
                pulse: true,
                status: {
                    fetching: false,
                    error: false,
                    loaded: true,
                    httpStatus: action.payload.status,
                },
            };
        case HEARTBEAT_ERROR: {
            return {
                ...state,
                pulse: false,
                status: {
                    fetching: false,
                    error: true,
                    loaded: false,
                    httpStatus: action.payload.status,
                },
            };
        }
        default:
            return state;
    }
}
